import { useCallback } from "react";

import type { DateRange } from "@/components/ui/calendar/types/calendar-range";

import { useMarketingCampaignFormModelContext } from "../../../../context";

export const useCinTerm = () => {
	const { viewModel, onSetViewModel } = useMarketingCampaignFormModelContext();
	const { cinStart, cinEnd } = viewModel;

	const onSetCinTerm = useCallback(
		(input: DateRange) => {
			onSetViewModel([
				{
					key: "cinStart",
					value: {
						...cinStart,
						value: input.from!,
					},
				},
				{
					key: "cinEnd",
					value: {
						...cinEnd,
						value: input.to!,
					},
				},
			]);
		},
		[cinEnd, cinStart, onSetViewModel],
	);

	return {
		cinStart,
		cinEnd,
		onSetCinTerm,
	};
};
